export default __webpack_public_path__ + "static/media/customer-support.3b58892d.webp";